module.exports = __webpack_public_path__ + "img/icon1.ce8465b5.png";